import { Card, Col, Row } from "react-bootstrap";
import {
  ISubmissionDetails,
  SubmissionOrObjection,
} from "../../../api/ISubmission";
import { SubmissionIcon } from "../../../leap-components/icons/LeapIcons";

interface SubmissionHeaderProps {
  submissionDetails: ISubmissionDetails;
}

const SubmissionHeader = ({ submissionDetails }: SubmissionHeaderProps) => {
  return (
    <Card className="flex-fill w-100">
      <Card.Header></Card.Header>
      <Card.Body className="pt-0">
        <Row>
          <Col className="col-12 col-md-6">
            <table className="no-border" style={{ marginTop: "0.6rem" }}>
              <tbody>
                <tr>
                  <td>
                    <SubmissionIcon />
                  </td>
                  <td>
                    <h2>
                      {SubmissionOrObjection(submissionDetails.type)}:{" "}
                      {submissionDetails.casenumber}
                    </h2>
                  </td>
                </tr>
              </tbody>
            </table>
            <div className="d-md-none" style={{ height: "20px" }}></div>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default SubmissionHeader;
